<div class="top-dialog-content">
  <div class="dialog-close">
    <span class="close-button" (click)="close()">
      <span>{{ 'admin.store.close' | translate }}</span>
      <app-icon icon="fas fa-times"></app-icon>
    </span>
  </div>
  <div class="form-group" id="popup-content">
    <ng-container *ngIf="showInitialContent; else newTokenTemplate">
      <div class="text-primary font-size-header mb-3">
        {{ 'admin.global.apiTokenGeneration' | translate }}
      </div>
      <p>{{ 'admin.global.clickGenerateToken' | translate }}</p>
      <p>
        <strong>{{ 'admin.global.overwriteGenerateToken' | translate }}</strong>
      </p>
      <app-button
        variant="primary"
        classes="btn-class px-4"
        type="button"
        (click)="generateNewToken()"
      >
        {{ 'admin.global.generateNewToken' | translate }}
      </app-button>
    </ng-container>
    <ng-template #newTokenTemplate>
      <div class="text-primary font-size-header mb-3">
        {{ 'admin.global.newApiToken' | translate }}
      </div>
      <p>
        <strong>{{
          'admin.global.newApiTokenSecurityWarning' | translate
        }}</strong>
      </p>
      <div class="form-group">
        <label for="token-description">
          {{ 'admin.global.yourApiTokenGrants' | translate }}
        </label>
        <div class="row mt-3">
          <div class="col-md-12">
            <label class="d-flex">
              <app-input-text
                class="flex-grow-1"
                [bare]="true"
                inputId="token-description"
                placeholder="Enter description"
                [value]="description"
                (inputEvent)="description = $any($event.target).value"
              ></app-input-text>
              <i
                class="far fa-copy copyUrlIcon ml-2 my-auto"
                title="Copy"
                (click)="copyToken()"
              ></i>
            </label>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
